import React from 'react'
import '../orgChart.scss'

const PersonCard = ({ person, onClick }) => {
  return (
    <div className="org-chart-person-card" onClick={onClick}>
      <div className="org-chart-person-name">{person.name}</div>
      <div className="org-chart-person-info">
        {person.studio} 스튜디오
        <span className="org-chart-person-divider" />
        {person.team}팀
      </div>
    </div>
  )
}

export default PersonCard
